module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/devices.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/devices.png
// module id = 481
// module chunks = 0